import IztTextarea from './src/izt-textarea'

IztTextarea.install = Vue => {
  Vue.component(IztTextarea.name, IztTextarea)
}

export default IztTextarea